import React from "react";
import { Input } from "rsuite";

import styled from "styled-components";


const TextareaInput = React.forwardRef(({ children, ...props }, ref) => (
    <Input {...props} ref={ref} as="textarea" />
));

TextareaInput.displayName = "TextareaInput";

export const CustomTextarea = styled(TextareaInput)`
    &&& {
        display: block;
        padding-top: 7px;
        resize: auto;
        text-align: left;
        vertical-align: top;

        &::placeholder {
            text-align: left;
        }
    }
`;
